<adapt-two-column-page>
    <div left-column>
        <adapt-dashboard-element [info]="CulturalCohortTooltip"
                                 [name]="cohortName">
            <dx-list *adaptLoadingUntilFirstEmit="let culturalCohort of cohort$"
                     class="dx-list-boxed mb-3"
                     [dataSource]="culturalCohort"
                     selectionMode="single"
                     [focusStateEnabled]="false"
                     [selectedItems]="[selectedCohortMember]"
                     (onSelectionChanged)="onPrimaryListSelectionChanged($event)">
                <div *dxTemplate="let member of 'item'">
                    <ng-container *ngTemplateOutlet="culturalRelationshipPersonTemplate; context: { member: member }"></ng-container>
                </div>
            </dx-list>

            <adapt-collapsible-dashboard-element [info]="SupportingMemberTooltip"
                                                 [collapsed]="hasCohortMembers"
                                                 class="supporting"
                                                 name="Supporting members">
                <dx-list [dataSource]="supportingMembers"
                         [focusStateEnabled]="false"
                         (onInitialized)="supportingMembersList = $event.component"
                         [grouped]="true"
                         [collapsibleGroups]="true"
                         [selectedItems]="[selectedCohortMember]"
                         class="dx-list-boxed"
                         selectionMode="single">
                    <div *dxTemplate="let group of 'group'">
                        @if (group.key) {
                            <adapt-link-person [personId]="group.key"
                                               [adaptLinkDisabled]="true"></adapt-link-person>
                        } @else {
                            <span>(No cultural leader)</span>
                        }
                    </div>
                    <div *dxTemplate="let data of 'item'">
                        <ng-container
                                      *ngTemplateOutlet="culturalRelationshipPersonTemplate; context: { member: data.member }"></ng-container>
                    </div>
                </dx-list>
            </adapt-collapsible-dashboard-element>
        </adapt-dashboard-element>
    </div>

    <div right-column>
        @if (selectedCohortMember) {
            <adapt-dashboard-element [name]="selectedCohortMember.relationship.person.fullName">
                <div adapt-dashboard-title-buttons>
                    <button *adaptIfAuthorised="EditCareerValuationForPerson; entity: selectedCohortMember.relationship.person"
                            adaptButton="add"
                            (click)="recordCVT()">Career Valuation</button>
                    <button *adaptIfAuthorised="EditCulturalIndexForPerson; entity: selectedCohortMember.relationship.person"
                            adaptButton="add"
                            (click)="recordCI()">Cultural Index</button>
                </div>

                @if (canReadCVDataForSelectedCohortMember) {
                    <div data-test="next-career-valuation-due"
                         class="mb-3">
                        <ng-container *ngTemplateOutlet="
                                activityInfoTemplate;
                                context: {
                                    type: CulturalActivityType.CareerValuation,
                                }
                            "></ng-container>
                    </div>
                    <div data-test="career-valuation">
                        <adapt-cvt-history [personId]="selectedCohortMember.relationship.personId"
                                           [showGrid]="false"></adapt-cvt-history>
                    </div>

                    @if (canReadCIDataForSelectedCohortMember) {
                        <!-- separator only if both show -->
                        <hr />
                    }
                }

                @if (canReadCIDataForSelectedCohortMember) {
                    <div data-test="next-cultural-index-due"
                         class="mb-3">
                        <ng-container *ngTemplateOutlet="
                                activityInfoTemplate;
                                context: {
                                    type: CulturalActivityType.CulturalIndex,
                                }
                            "></ng-container>
                    </div>
                    <div data-test="cultural-index">
                        <adapt-ci-history [personId]="selectedCohortMember.relationship.personId"
                                          [showGrid]="false"></adapt-ci-history>
                    </div>
                }
            </adapt-dashboard-element>

            <ng-template #activityInfoTemplate
                         let-type="type">
                @let activity = type === CulturalActivityType.CareerValuation ? selectedCohortMember.nextCVTActivity : selectedCohortMember.nextCIActivity;
            @let nextCatchupDate = type === CulturalActivityType.CareerValuation ? selectedCohortMember.nextCVT : selectedCohortMember.nextCI;
            @let isSuggestedDate = !activity && !!nextCatchupDate;
            @let fullTypeName = getFullTypeName(type);

            <b>Next {{ fullTypeName }} due</b>:
            <div class="d-inline-block"
                 #tooltipTarget
                 [adaptTooltip]="isSuggestedDate ? `This is a suggested date, there is no ${fullTypeName.toLocaleLowerCase()} scheduled for this person yet` : undefined">
                <span [class.opacity-50]="isSuggestedDate"
                      data-test="next-catchup-date">{{ nextCatchupDate ? (nextCatchupDate | adaptDate) : "never" }}</span>
                @if (activity && activity.extensions.hasRescheduled) {
                    <adapt-activity-rescheduled-info class="ms-1"
                                                     [activity]="activity"
                                                     [tooltipTarget]="tooltipTarget"></adapt-activity-rescheduled-info>
                } @else if (isSuggestedDate) {
                    <i class="fal fa-info-circle ms-1"></i>
                }
            </div>
            @if (selectedCohortMember.primaryCulturalLeaderId) {
                <div>
                    @if (activity) {
                        <button adaptButton="editLink"
                                [attr.data-test]="`reschedule-${type.toLocaleLowerCase()}-activity-button`"
                                (click)="rescheduleEvent(activity)">Reschedule {{ fullTypeName }}</button>
                    } @else {
                        <button adaptButton="addLink"
                                [attr.data-test]="`schedule-${type.toLocaleLowerCase()}-activity-button`"
                                (click)="scheduleEvent(type)">Schedule {{ fullTypeName }}</button>
                    }
                </div>
            }
            </ng-template>
            }
    </div>

    <ng-template #culturalRelationshipPersonTemplate
                 let-member="member">
        @if (member) {
            <div (click)="onSelectionChanged(member)"
                 class="d-flex flex-row gap-3 align-items-center">
                @if (member.relationship) {
                    <adapt-link-person [personId]="member.relationship.personId"
                                       [showImage]="true"
                                       [showText]="true"
                                       [adaptLinkDisabled]="true"
                                       class="flex-grow-1"></adapt-link-person>
                }
                <div class="d-flex flex-column gap-1 align-items-end">
                    @if (member.catchupStatus) {
                        <span class="badge"
                              [ngClass]="member.catchupStatus.badgeClass">{{ member.catchupStatus.defaultLabel }}</span>
                    }
                    @if (member.nextCatchup) {
                        <span>Due: {{ member.nextCatchup | adaptDate }}</span>
                    }
                </div>
            </div>
        }
    </ng-template>
</adapt-two-column-page>
